import { requestImportMeetingJSON, requestMeetingJSON } from '../../connection/meeting';
import { ScheduledStreamResponse } from '../types/connection';
import { RoomStates } from '../../types/enums';
import { EnablerStates } from '../../stores/types/session';


interface Action {
	type: string;
	payload: any;
	remote?: boolean;
}

export const EXPORT_MEETING_JSON = 'export_meeting_json';
export const IMPORT_MEETING_JSON = 'import_meeting_json';

export const exportMeetingJSON = (token: string, meeting: number | string, title: string) => ({
	type: EXPORT_MEETING_JSON,
	promise: requestMeetingJSON(token, meeting, title),
});

export const importMeetingJSON = (
	token: string,
	meetingData: string,
	channel: number,
	cb: Function,
) => ({
	type: IMPORT_MEETING_JSON,
	promise: requestImportMeetingJSON(token, meetingData, channel, cb),
});

export const SET_CANVAS_VOLUME_BACKSTAGE = 'SET_CANVAS_VOLUME_BACKSTAGE';
export function setBackstageCanvasVolume(backstageCanvasVolume: number): Action {
	return {
		type: SET_CANVAS_VOLUME_BACKSTAGE,
		payload: backstageCanvasVolume,
	};
}

export const SET_SCHEDULED_STREAM = 'SET_SCHEDULED_STREAM';
export function setScheduledStream(scheduledStream: ScheduledStreamResponse | null): Action {
	return {
		type: SET_SCHEDULED_STREAM,
		payload: scheduledStream,
	};
}

export const SET_ROOM_STATE = 'SET_ROOM_STATE';
export function setRoomState(roomState: RoomStates): Action {
	return {
		type: SET_ROOM_STATE,
		payload: roomState,
	};
}

export const SET_ROOM_STATE_TRANSITIONING = 'SET_ROOM_STATE_TRANSITIONING';
export function setRoomStateTransitioning(roomStateTransitioning: boolean): Action {
	return {
		type: SET_ROOM_STATE_TRANSITIONING,
		payload: roomStateTransitioning,
	};
}

export const SET_ENABLER_SHOT_ID = 'SET_ENABLER_SHOT_ID';
export function setEnablerShotId(enablerShotId: number): Action {
	return {
		type: SET_ENABLER_SHOT_ID,
		payload: enablerShotId,
	};
}

export const SET_ENABLER_STATE = 'SET_ENABLER_STATE';
export function setEnablerState(enablerState: EnablerStates): Action {
	return {
		type: SET_ENABLER_STATE,
		payload: enablerState,
	};
}